<template>
  <div
    class="animated-text-by-line"
    ref="refRoot"
  >
    <!-- <slot /> -->
    <SplitLines type="lines">
      <slot />
    </SplitLines>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  auto: {
    default: true,
  },
})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

const reset = function () {
  const timeline = $gsap.timeline()
  if (!refRoot.value) return
  timeline.set(refRoot.value.querySelectorAll(".line"), {
    y: 50,
    opacity: 0,
  })

  return timeline
}

const animateIn = function ({ tl, label, opts } = {}) {
  const timeline = $gsap.timeline({ ...opts })
  if (!refRoot.value) return
  timeline.fromTo(
    refRoot.value.querySelectorAll(".line"),
    {
      y: 50,
      opacity: 0,
    },
    {
      y: 0,
      opacity: 1,
      duration: 0.6,
      stagger: 0.1,
    }
  )

  if (tl) {
    tl.add(timeline, label)
  }

  return timeline
}

const animateOut = function ({ tl, label, opts } = {}) {
  const timeline = $gsap.timeline({ ...opts })
  if (!refRoot.value) return
  timeline.to(refRoot.value.querySelectorAll(".line"), {
    y: -50,
    opacity: 0,
    duration: 0.2,
    stagger: 0.1,
  })

  if (tl) {
    tl.add(timeline, label)
  }

  return timeline
}

useScrollTrigger(() => {
  if (!props.auto) return
  // console.log("AnimatedTextByLine.scrollTrigger")

  let tl = $gsap.timeline({
    scrollTrigger: {
      trigger: refRoot.value,
      start: "top bottom",
      end: "top top",
      onEnter: animateIn,
      onLeave: animateOut,
      onEnterBack: animateIn,
      onLeaveBack: animateOut,
    },
  })

  return tl
})

defineExpose({
  reset,
  animateIn,
  animateOut,
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";
</style>
